import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountSectionCardComponent } from './account-section-card';
import { AccountBadgeItem } from './accounts-information.models';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-account-achievements-section',
  standalone: true,
  imports: [CommonModule, AccountSectionCardComponent, TranslatePipe],
  template: `
    <app-account-section-card [title]="'accountsInformation.sections.achievementsTrustBadges' | translate" iconClass="fa-solid fa-award">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-3.5 sm:gap-4 antialiased">
        @for (item of items; track item.title) {
          <div
            class="flex items-start gap-4 p-4 bg-surface-elevated hover:bg-surface border border-border-subtle hover:border-border-primary rounded-2xl transition-all duration-200 group hover:shadow-subtle"
          >
            <div
              class="w-10 h-10 rounded-xl flex items-center justify-center shrink-0 border shadow-sm transition-transform group-hover:scale-105"
              [ngClass]="getBadgeColorSpecs(item.title, item.iconClass).css"
            >
              <i
                [class]="
                  getBadgeColorSpecs(item.title, item.iconClass).icon + ' text-xs sm:text-sm'
                "
              ></i>
            </div>

            <div class="space-y-0.5">
              <div
                class="text-xs sm:text-sm font-black text-text-primary tracking-tight transition-colors group-hover:text-text-primary"
              >
                {{ item.title.startsWith('accountsInformation.') ? (item.title | translate) : item.title }}
              </div>
              <p
                class="text-[11px] sm:text-xs font-medium text-text-secondary leading-relaxed text-justify"
              >
                {{ item.description.startsWith('accountsInformation.') ? (item.description | translate) : item.description }}
              </p>
            </div>
          </div>
        } @empty {
          <div
            class="col-span-full py-6 flex flex-col items-center justify-center border border-dashed border-border-subtle rounded-2xl bg-surface-elevated text-center font-mono"
          >
            <i class="fa-solid fa-shield-halved text-text-muted text-lg mb-2"></i>
            <span class="text-[10px] font-black uppercase tracking-wider text-text-muted"
              >{{ 'accountsInformation.empty.badges' | translate }}</span
            >
          </div>
        }
      </div>
    </app-account-section-card>
  `,
})
export class AccountAchievementsSectionComponent {
  @Input() items: AccountBadgeItem[] = [];

  /**
   * ── Smart Chromatic Aesthetic Dispatcher ──
   * تلوين وفصل الأوسمة ديناميكياً لتشجيع الرؤية البصرية المنظمة للثقة
   */
  getBadgeColorSpecs(title: string, defaultIcon: string): { css: string; icon: string } {
    const text = title?.toLowerCase() || '';
    const baseIcon = defaultIcon || 'fa-solid fa-medal';

    // 1. أوسمة التوثيق والهوية الرسمية (اللون الكهرماني/الذهبي الفاخر)
    if (
      text.includes('verified') ||
      text.includes('identity') ||
      text.includes('identity') ||
      text.includes('توثيق')
    ) {
      return {
        css: 'bg-warning-soft border-warning/20 text-warning',
        icon: 'fa-solid fa-shield-check',
      };
    }
    // 2. أوسمة الأداء السريع والتواصل (اللون الأزرق الانسيابي)
    if (
      text.includes('fast') ||
      text.includes('reply') ||
      text.includes('response') ||
      text.includes('سريع')
    ) {
      return { css: 'bg-info-soft border-info/20 text-info', icon: 'fa-solid fa-bolt' };
    }
    // 3. أوسمة التقييمات العالية وحجوزات التميز (اللون الزمردي الناصع)
    if (
      text.includes('top') ||
      text.includes('expert') ||
      text.includes('super') ||
      text.includes('مميز')
    ) {
      return {
        css: 'bg-success-soft border-success/20 text-success',
        icon: 'fa-solid fa-crown',
      };
    }

    // Fallback الافتراضي بالهوية الأصلية المحدثة ناعماً للـ HomiGo
    return { css: 'bg-primary/10 border-primary/20 text-primary', icon: baseIcon };
  }
}
